import React, { useState, useEffect } from 'react';
import './LGPDTermsPage.css';

export default function LGPDTermsPage() {
  const [activeSection, setActiveSection] = useState('');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const sections = [
    { id: 'intro', label: 'Introdução' },
    { id: 'definicoes', label: '1. Definições' },
    { id: 'requisitos', label: '3. Requisitos para utilização' },
    { id: 'servicos', label: '4. Serviços oferecidos' },
    { id: 'natureza', label: '5. Natureza dos resultados' },
    { id: 'consulta-avulsa', label: '6. Consulta avulsa' },
    { id: 'conta-auto', label: '7. Criação automática de conta' },
    { id: 'responsabilidade', label: '8. Responsabilidade pela conta' },
    { id: 'creditos', label: '9. Créditos' },
    { id: 'creditos-comprados', label: '10. Créditos comprados' },
    { id: 'creditos-promo', label: '11. Créditos promocionais' },
    { id: 'ordem-consumo', label: '12. Ordem de consumo dos saldos' },
    { id: 'pacotes', label: '13. Pacotes e bônus' },
    { id: 'precos', label: '14. Preços e pagamentos' },
    { id: 'cancelamento', label: '15. Cancelamento, arrependimento e reembolso' },
    { id: 'sem-resultado', label: '16. Consultas sem resultado' },
    { id: 'uso-permitido', label: '17. Utilização permitida' },
    { id: 'proibido', label: '18. Condutas proibidas' },
    { id: 'finalidade', label: '19. Finalidade da consulta' },
    { id: 'auditoria', label: '20. Auditoria e monitoramento' },
    { id: 'suspensao', label: '21. Suspensão e cancelamento de contas' },
    { id: 'disponibilidade', label: '22. Disponibilidade da plataforma' },
    { id: 'fontes', label: '23. Atualização e disponibilidade das fontes' },
    { id: 'decisoes', label: '24. Decisões tomadas pelo usuário' },
    { id: 'protecao-dados', label: '25. Proteção de dados pessoais' },
    { id: 'comunicacoes', label: '26. Comunicações' },
    { id: 'propriedade', label: '27. Propriedade intelectual' },
    { id: 'terceiros', label: '28. Links e serviços de terceiros' },
    { id: 'limitacao', label: '29. Limitação de responsabilidade' },
    { id: 'indenizacao', label: '30. Indenização por uso indevido' },
    { id: 'encerramento', label: '31. Encerramento da conta pelo usuário' },
    { id: 'alteracoes-servicos', label: '32. Alterações dos serviços' },
    { id: 'alteracoes-termos', label: '33. Alterações destes Termos' },
    { id: 'legislacao', label: '34. Legislação aplicável' },
    { id: 'foro', label: '35. Foro' },
    { id: 'atendimento', label: '36. Atendimento' },
  ];

  useEffect(() => {
    const handleScroll = () => {
      const sectionElements = sections.map(s => document.getElementById(s.id)).filter(Boolean);
      for (let i = sectionElements.length - 1; i >= 0; i--) {
        const el = sectionElements[i];
        const rect = el.getBoundingClientRect();
        if (rect.top <= 120) {
          setActiveSection(sections[i].id);
          break;
        }
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <div className="lgpd-root">
      {/* Header */}
      <header className="lgpd-header">
        <div className="container">
          <div className="lgpd-header-inner">
            <a href="/" className="lgpd-logo">Análise Central</a>
            <nav className="lgpd-header-nav">
              <a href="/">Página Inicial</a>
              <a href="#" className="active">Termos de Uso</a>
              <a href="/lgpd/privacy">Política de Privacidade</a>
            </nav>
          </div>
        </div>
      </header>

      {/* Hero */}
      <div className="lgpd-hero">
        <div className="container">
          <span className="lgpd-hero-label">Documento Legal</span>
          <h1>Termos de Uso</h1>
          <p className="lgpd-hero-meta">
            <span>Última atualização: <strong>01 de Fevereiro de 2023</strong></span>
            <span className="dot">•</span>
            <span>Versão: <strong>1.2</strong></span>
          </p>
        </div>
      </div>

      <div className="lgpd-layout container">
        {/* Sidebar */}
        <aside className={`lgpd-sidebar ${mobileMenuOpen ? 'open' : ''}`}>
          <button 
            className="lgpd-mobile-toggle"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <span>📑 Índice dos Termos</span>
            <span className="chevron">{mobileMenuOpen ? '▲' : '▼'}</span>
          </button>
          <nav className="lgpd-toc">
            <div className="toc-title">Índice</div>
            {sections.map(s => (
              <button
                key={s.id}
                className={`toc-link ${activeSection === s.id ? 'active' : ''}`}
                onClick={() => scrollTo(s.id)}
              >
                {s.label}
              </button>
            ))}
          </nav>
        </aside>

        {/* Content */}
        <main className="lgpd-content">
          {/* Intro */}
          <section id="intro" className="lgpd-section">
            <div className="intro-box">
              <p>
                Estes Termos de Uso regulam o acesso e a utilização do site, da plataforma e dos serviços 
                oferecidos pela <strong>Análise Cadastral</strong>.
              </p>
              <p>
                Ao criar uma conta, adquirir uma consulta avulsa, comprar créditos, acessar um resultado 
                ou utilizar qualquer funcionalidade da plataforma, o usuário declara que leu, compreendeu 
                e concordou com estes Termos de Uso e com a <a href="#">Política de Privacidade</a>.
              </p>
              <div className="alert-box">
                <span className="alert-icon">⚠️</span>
                <span>Caso não concorde com alguma condição, não deverá utilizar os serviços.</span>
              </div>
            </div>
          </section>

          {/* 1. Definições */}
          <section id="definicoes" className="lgpd-section">
            <h2>1. Definições</h2>
            <p>Para facilitar a compreensão destes Termos:</p>
            <ul className="def-list">
              <li><strong>Análise Cadastral:</strong> empresa responsável pela disponibilização da plataforma;</li>
              <li><strong>Plataforma:</strong> site, sistema, área restrita e demais ambientes digitais da Análise Cadastral;</li>
              <li><strong>Usuário:</strong> pessoa física ou representante autorizado de pessoa jurídica que utiliza os serviços;</li>
              <li><strong>Consulta:</strong> pesquisa realizada por meio dos critérios disponibilizados na plataforma;</li>
              <li><strong>Consulta simples:</strong> modalidade de consulta que consome, atualmente, <strong>100 créditos</strong>;</li>
              <li><strong>Consulta completa:</strong> modalidade de consulta que consome, atualmente, <strong>500 créditos</strong>;</li>
              <li><strong>Créditos comprados:</strong> créditos adquiridos mediante pagamento;</li>
              <li><strong>Créditos promocionais:</strong> créditos concedidos gratuitamente, sujeitos a prazo de validade e condições específicas;</li>
              <li><strong>Consulta avulsa:</strong> consulta adquirida fora do fluxo regular de compra de créditos;</li>
              <li><strong>Resultado:</strong> arquivo, relatório, informação, possível correspondência ou conjunto de dados apresentado após uma consulta.</li>
            </ul>
          </section>

          {/* 3. Requisitos */}
          <section id="requisitos" className="lgpd-section">
            <h2>3. Requisitos para utilização</h2>
            <p>A plataforma é destinada a usuários <strong>maiores de 18 anos</strong> e civilmente capazes.</p>
            <p>Ao utilizar o serviço, o usuário declara que:</p>
            <ul>
              <li>possui capacidade legal para contratar;</li>
              <li>forneceu informações verdadeiras e atualizadas;</li>
              <li>utilizará os resultados somente para finalidades legítimas;</li>
              <li>respeitará a privacidade e os direitos de terceiros;</li>
              <li>não utilizará a plataforma para atividades ilegais, abusivas ou fraudulentas.</li>
            </ul>
            <p>Quando o usuário atuar em nome de uma empresa, declara possuir autorização para representá-la e contratar os serviços.</p>
          </section>

          {/* 4. Serviços */}
          <section id="servicos" className="lgpd-section">
            <h2>4. Serviços oferecidos</h2>
            <p>A Análise Cadastral poderá disponibilizar consultas a partir de informações como:</p>
            <ul>
              <li>CPF;</li>
              <li>nome;</li>
              <li>telefone;</li>
              <li>endereço de e-mail;</li>
              <li>nome associado a uma transação PIX;</li>
              <li>seis dígitos centrais de um documento exibido em uma transação PIX;</li>
              <li>outros parâmetros apresentados na plataforma.</li>
            </ul>
            <p>Cada consulta poderá apresentar diferentes tipos e quantidades de informações, conforme:</p>
            <ul>
              <li>o parâmetro utilizado;</li>
              <li>a modalidade contratada;</li>
              <li>a disponibilidade das fontes consultadas;</li>
              <li>a existência de registros relacionados;</li>
              <li>a qualidade dos dados informados;</li>
              <li>as regras e limitações aplicáveis ao serviço.</li>
            </ul>
            <div className="info-box">
              <span className="info-icon">ℹ️</span>
              <span>A descrição, o preço e o consumo de créditos de cada consulta serão apresentados antes da confirmação da operação.</span>
            </div>
          </section>

          {/* 5. Natureza dos resultados */}
          <section id="natureza" className="lgpd-section">
            <h2>5. Natureza dos resultados</h2>
            <p>Os resultados poderão apresentar informações cadastrais, dados relacionados ou possíveis correspondências encontradas a partir dos parâmetros informados.</p>
            <p>A Análise Cadastral <strong>não garante</strong> que:</p>
            <ul>
              <li>toda consulta produzirá resultados;</li>
              <li>todas as informações estarão disponíveis;</li>
              <li>os dados estarão integralmente atualizados;</li>
              <li>uma correspondência represente confirmação definitiva de identidade;</li>
              <li>pessoas com nomes semelhantes ou dados parcialmente coincidentes não apareçam no resultado;</li>
              <li>o resultado seja suficiente, isoladamente, para determinada decisão.</li>
            </ul>
            <p>O usuário deverá analisar e validar os resultados antes de utilizá-los para qualquer finalidade relevante.</p>
            <p>Especialmente nas consultas realizadas por nome, telefone, e-mail ou informações parciais de PIX, o resultado poderá apresentar mais de uma possível correspondência.</p>
          </section>

          {/* 6. Consulta avulsa */}
          <section id="consulta-avulsa" className="lgpd-section">
            <h2>6. Consulta avulsa</h2>
            <p>A Análise Cadastral poderá oferecer uma consulta avulsa pelo valor anunciado no momento da contratação.</p>
            <p>Atualmente, a consulta avulsa poderá ser oferecida por <strong>R$ 16,90</strong>, sujeito a alteração mediante informação prévia antes da compra.</p>
            <p>Após a confirmação do pagamento:</p>
            <ul>
              <li>a consulta será processada;</li>
              <li>o resultado será enviado ou disponibilizado por meio de um link encaminhado ao e-mail informado;</li>
              <li>uma conta poderá ser criada automaticamente para o comprador;</li>
              <li>créditos promocionais poderão ser adicionados à nova conta.</li>
            </ul>
            <p>O link do resultado poderá permanecer disponível pelo prazo informado no e-mail de entrega.</p>
            <p>O usuário é responsável por:</p>
            <ul>
              <li>informar corretamente o endereço de e-mail;</li>
              <li>manter o acesso seguro à sua caixa de entrada;</li>
              <li>baixar ou consultar o resultado dentro do prazo disponibilizado;</li>
              <li>não compartilhar o arquivo ou o link com pessoas não autorizadas.</li>
            </ul>
          </section>

          {/* 7. Criação automática de conta */}
          <section id="conta-auto" className="lgpd-section">
            <h2>7. Criação automática de conta</h2>
            <p>Ao adquirir uma consulta avulsa, o usuário autoriza a criação de uma conta vinculada ao e-mail fornecido durante a compra.</p>
            <p>A conta poderá ser utilizada para:</p>
            <ul>
              <li>acessar o resultado da consulta;</li>
              <li>consultar o histórico disponível;</li>
              <li>utilizar créditos promocionais;</li>
              <li>adquirir novos créditos;</li>
              <li>realizar futuras consultas;</li>
              <li>administrar dados cadastrais e credenciais.</li>
            </ul>
            <p>A Análise Cadastral poderá enviar:</p>
            <ul>
              <li>link de ativação;</li>
              <li>senha temporária;</li>
              <li>código de acesso;</li>
              <li>link para criação de senha;</li>
              <li>orientações para o primeiro acesso.</li>
            </ul>
            <div className="alert-box alert-info">
              <span className="alert-icon">🔒</span>
              <span>Por segurança, o usuário deverá alterar qualquer senha temporária recebida e manter suas credenciais em sigilo.</span>
            </div>
          </section>

          {/* 8. Responsabilidade pela conta */}
          <section id="responsabilidade" className="lgpd-section">
            <h2>8. Responsabilidade pela conta</h2>
            <p>O usuário é responsável por todas as atividades realizadas em sua conta, salvo quando comprovado acesso indevido não causado por sua conduta.</p>
            <p>É obrigação do usuário:</p>
            <ul>
              <li>utilizar senha segura;</li>
              <li>não compartilhar suas credenciais;</li>
              <li>não permitir o uso da conta por terceiros não autorizados;</li>
              <li>manter seus dados atualizados;</li>
              <li>comunicar imediatamente qualquer acesso suspeito;</li>
              <li>encerrar a sessão em dispositivos compartilhados.</li>
            </ul>
            <p>A Análise Cadastral poderá exigir verificações adicionais de identidade ou segurança antes de liberar determinadas funcionalidades.</p>
          </section>

          {/* 9. Créditos */}
          <section id="creditos" className="lgpd-section">
            <h2>9. Créditos</h2>
            <p>As consultas realizadas dentro da plataforma poderão ser cobradas por meio de créditos.</p>
            <p>Atualmente:</p>
            <ul>
              <li>uma consulta simples consome <strong>200 créditos</strong>;</li>
              <li>uma consulta completa consome <strong>500 créditos</strong>.</li>
            </ul>
            <p>A quantidade necessária poderá variar conforme o tipo de consulta e será sempre apresentada antes da confirmação.</p>
            <p>A Análise Cadastral poderá atualizar:</p>
            <ul>
              <li>o consumo de créditos;</li>
              <li>os tipos de consulta;</li>
              <li>os pacotes disponíveis;</li>
              <li>os preços;</li>
              <li>as regras promocionais.</li>
            </ul>
            <p>As alterações não reduzirão créditos já adquiridos, mas poderão afetar o número de créditos necessário para consultas futuras, mediante comunicação adequada na plataforma.</p>
          </section>

          {/* 10. Créditos comprados */}
          <section id="creditos-comprados" className="lgpd-section">
            <h2>10. Créditos comprados</h2>
            <p>Os créditos adquiridos mediante pagamento:</p>
            <ul>
              <li>serão adicionados após a confirmação da transação;</li>
              <li>validade de <strong>90 dias</strong>;</li>
              <li>não poderão ser convertidos em dinheiro;</li>
              <li>não poderão ser transferidos entre contas sem autorização;</li>
              <li>deverão ser utilizados dentro da própria plataforma.</li>
            </ul>
            <p>Eventuais estornos ou restituições seguirão a legislação aplicável e as regras destes Termos.</p>
          </section>

          {/* 11. Créditos promocionais */}
          <section id="creditos-promo" className="lgpd-section">
            <h2>11. Créditos promocionais</h2>
            <p>A Análise Cadastral poderá oferecer créditos promocionais em campanhas, compras, consultas avulsas ou ações de boas-vindas.</p>
            <p>Na oferta atualmente prevista, o comprador de uma consulta avulsa poderá receber <strong>400 créditos promocionais</strong>.</p>
            <p>Salvo condição diferente apresentada na campanha:</p>
            <ul>
              <li>os créditos promocionais serão válidos por <strong>30 dias</strong>;</li>
              <li>a validade será contada a partir da concessão;</li>
              <li>o saldo expirado será automaticamente removido;</li>
              <li>créditos expirados não serão reativados;</li>
              <li>o saldo promocional não poderá ser convertido em dinheiro;</li>
              <li>o saldo promocional não poderá ser transferido;</li>
              <li>o benefício poderá ser concedido uma única vez por usuário, CPF, e-mail, telefone, dispositivo ou meio de pagamento.</li>
            </ul>
            <p>A Análise Cadastral poderá impedir múltiplas concessões quando identificar cadastros duplicados, uso abusivo ou tentativa de obtenção indevida do benefício.</p>
          </section>

          {/* 12. Ordem de consumo */}
          <section id="ordem-consumo" className="lgpd-section">
            <h2>12. Ordem de consumo dos saldos</h2>
            <p>Quando a conta possuir créditos comprados e créditos promocionais, será utilizada a seguinte ordem:</p>
            <ol>
              <li>primeiro, os créditos comprados;</li>
              <li>depois, os créditos promocionais.</li>
            </ol>
            <p>O usuário reconhece que os créditos promocionais poderão expirar mesmo que ainda existam créditos comprados em sua conta.</p>
            <p>A data de validade do saldo promocional será apresentada na área do usuário sempre que tecnicamente possível.</p>
          </section>

          {/* 13. Pacotes e bônus */}
          <section id="pacotes" className="lgpd-section">
            <h2>13. Pacotes e bônus</h2>
            <p>A Análise Cadastral poderá comercializar pacotes contendo créditos comprados e créditos promocionais.</p>
            <p>As condições de cada pacote poderão incluir:</p>
            <ul>
              <li>preço;</li>
              <li>quantidade de créditos comprados;</li>
              <li>quantidade de créditos promocionais;</li>
              <li>prazo de validade do bônus;</li>
              <li>estimativa de consultas possíveis;</li>
              <li>custo médio estimado por consulta.</li>
            </ul>
            <p>Quando uma oferta mencionar "até" determinada quantidade de consultas, o cálculo considerará:</p>
            <ul>
              <li>o consumo integral dos créditos comprados;</li>
              <li>o consumo integral dos créditos promocionais;</li>
              <li>a utilização do bônus dentro de sua validade;</li>
              <li>o custo atual da modalidade utilizada.</li>
            </ul>
            <p>A quantidade efetiva poderá variar conforme os tipos de consulta escolhidos pelo usuário.</p>
          </section>

          {/* 14. Preços e pagamentos */}
          <section id="precos" className="lgpd-section">
            <h2>14. Preços e pagamentos</h2>
            <p>Os preços serão apresentados em reais antes da conclusão da compra.</p>
            <p>O pagamento poderá ser realizado pelos meios disponibilizados no site, como PIX, cartão ou outros provedores autorizados.</p>
            <p>A liberação poderá depender:</p>
            <ul>
              <li>da confirmação do pagamento;</li>
              <li>da análise antifraude;</li>
              <li>da validação dos dados da transação;</li>
              <li>da disponibilidade do meio de pagamento.</li>
            </ul>
            <p>A Análise Cadastral não armazena necessariamente os dados completos de cartões, que poderão ser processados diretamente por empresas especializadas.</p>
            <p>O usuário deverá verificar todas as informações antes de confirmar a compra.</p>
          </section>

          {/* 15. Cancelamento */}
          <section id="cancelamento" className="lgpd-section">
            <h2>15. Cancelamento, arrependimento e reembolso</h2>
            <p>Solicitações de cancelamento, arrependimento ou reembolso serão analisadas conforme:</p>
            <ul>
              <li>a legislação aplicável;</li>
              <li>o momento da solicitação;</li>
              <li>a execução ou não do serviço;</li>
              <li>a utilização dos créditos;</li>
              <li>o acesso ao resultado;</li>
              <li>a natureza do produto ou serviço contratado.</li>
            </ul>
            <p>Para solicitar atendimento, o usuário deverá entrar em contato pelo e-mail:</p>
            <div className="contact-box">
              <a href="mailto:suporte@analisecentral.com.br">suporte@analisecentral.com.br</a>
            </div>
            <p>A solicitação deverá conter:</p>
            <ul>
              <li>nome;</li>
              <li>e-mail utilizado na compra;</li>
              <li>identificação da transação;</li>
              <li>data da compra;</li>
              <li>motivo do pedido.</li>
            </ul>
            <p>Nada nestes Termos limita direitos obrigatórios assegurados ao consumidor pela legislação aplicável.</p>
            <p>Em casos de pagamento duplicado, cobrança indevida ou falha comprovada na entrega do serviço, a Análise Cadastral avaliará a correção, nova disponibilização, estorno ou solução adequada.</p>
          </section>

          {/* 16. Consultas sem resultado */}
          <section id="sem-resultado" className="lgpd-section">
            <h2>16. Consultas sem resultado</h2>
            <p>A ausência de resultado não significa necessariamente falha na prestação do serviço.</p>
            <p>Uma consulta poderá não retornar informações quando:</p>
            <ul>
              <li>os dados informados estiverem incorretos;</li>
              <li>não houver registros disponíveis;</li>
              <li>as fontes consultadas não possuírem correspondências;</li>
              <li>existirem limitações técnicas ou legais;</li>
              <li>os parâmetros forem insuficientes;</li>
              <li>houver indisponibilidade temporária.</li>
            </ul>
            <p>A política comercial aplicável a consultas sem resultado deverá ser apresentada antes da contratação ou na descrição de cada serviço.</p>
            <div className="highlight-box">
              <span className="highlight-icon">✓</span>
              <span><strong>Regra adotada pela plataforma:</strong> Consulta sem resultados não são cobrados.</span>
            </div>
          </section>

          {/* 17. Utilização permitida */}
          <section id="uso-permitido" className="lgpd-section">
            <h2>17. Utilização permitida</h2>
            <p>A plataforma deverá ser utilizada somente para finalidades legítimas, específicas e compatíveis com a legislação.</p>
            <p>Entre as finalidades possíveis, conforme o contexto e a existência de fundamento adequado, estão:</p>
            <ul>
              <li>validação de dados fornecidos pelo próprio titular;</li>
              <li>atualização cadastral;</li>
              <li>prevenção a fraudes;</li>
              <li>confirmação de informações em relações comerciais;</li>
              <li>análise de possíveis inconsistências;</li>
              <li>localização de registros relacionados;</li>
              <li>execução de procedimentos solicitados pelo próprio titular;</li>
              <li>exercício regular de direitos.</li>
            </ul>
            <div className="alert-box">
              <span className="alert-icon">⚠️</span>
              <span>A simples disponibilidade de uma consulta não autoriza qualquer forma de uso dos resultados.</span>
            </div>
          </section>

          {/* 18. Condutas proibidas */}
          <section id="proibido" className="lgpd-section">
            <h2>18. Condutas proibidas</h2>
            <p>É proibido utilizar a plataforma ou seus resultados para:</p>
            <ul className="prohibited-list">
              <li>perseguição ou monitoramento abusivo;</li>
              <li>ameaça, intimidação ou constrangimento;</li>
              <li>chantagem ou extorsão;</li>
              <li>discriminação;</li>
              <li>exposição pública de dados pessoais;</li>
              <li>invasão de privacidade;</li>
              <li>fraude ou falsidade ideológica;</li>
              <li>obtenção de vantagem ilícita;</li>
              <li>comercialização ou redistribuição não autorizada de dados;</li>
              <li>criação de listas para spam;</li>
              <li>envio abusivo de mensagens;</li>
              <li>assédio;</li>
              <li>doxing ou divulgação de informações para causar danos;</li>
              <li>localização de vítimas para prática de crimes;</li>
              <li>consulta motivada por curiosidade sem finalidade legítima;</li>
              <li>violação de direitos de terceiros;</li>
              <li>tentativa de contornar limites ou controles da plataforma;</li>
              <li>acesso automatizado sem autorização;</li>
              <li>raspagem, cópia em massa ou extração sistemática;</li>
              <li>revenda de acessos ou resultados;</li>
              <li>compartilhamento de conta;</li>
              <li>utilização por menores sem autorização legal;</li>
              <li>qualquer atividade contrária à legislação.</li>
            </ul>
          </section>

          {/* 19. Finalidade da consulta */}
          <section id="finalidade" className="lgpd-section">
            <h2>19. Finalidade da consulta</h2>
            <p>A Análise Cadastral poderá solicitar que o usuário informe ou confirme a finalidade da consulta.</p>
            <p>O usuário declara que:</p>
            <ul>
              <li>possui motivo legítimo para realizar a pesquisa;</li>
              <li>utilizará somente os dados necessários;</li>
              <li>não conservará os resultados por prazo superior ao necessário;</li>
              <li>adotará medidas para proteger as informações;</li>
              <li>atenderá solicitações legítimas dos titulares quando aplicável.</li>
            </ul>
            <p>A Análise Cadastral poderá registrar a finalidade declarada para fins de segurança, auditoria, prevenção a fraudes e demonstração de conformidade.</p>
          </section>

          {/* 20. Auditoria */}
          <section id="auditoria" className="lgpd-section">
            <h2>20. Auditoria e monitoramento</h2>
            <p>A Análise Cadastral poderá manter registros relacionados a:</p>
            <ul>
              <li>usuário responsável;</li>
              <li>data e horário;</li>
              <li>endereço IP;</li>
              <li>dispositivo;</li>
              <li>tipo de consulta;</li>
              <li>parâmetro pesquisado;</li>
              <li>consumo de créditos;</li>
              <li>resultado gerado;</li>
              <li>acesso ou download do arquivo;</li>
              <li>finalidade declarada;</li>
              <li>atividades suspeitas.</li>
            </ul>
            <p>Esses registros poderão ser utilizados para segurança, atendimento, prevenção a fraudes, investigação de abuso, cumprimento de obrigações e exercício de direitos.</p>
          </section>

          {/* 21. Suspensão */}
          <section id="suspensao" className="lgpd-section">
            <h2>21. Suspensão e cancelamento de contas</h2>
            <p>A Análise Cadastral poderá limitar, suspender ou cancelar uma conta quando identificar:</p>
            <ul>
              <li>violação destes Termos;</li>
              <li>indícios de fraude;</li>
              <li>uso ilegal ou abusivo;</li>
              <li>compartilhamento indevido;</li>
              <li>tentativa de obtenção múltipla de bônus;</li>
              <li>contestação fraudulenta de pagamento;</li>
              <li>risco para titulares ou terceiros;</li>
              <li>acesso automatizado não autorizado;</li>
              <li>determinação legal ou de autoridade competente;</li>
              <li>risco à segurança da plataforma.</li>
            </ul>
            <p>Quando possível e adequado, o usuário será informado sobre a medida.</p>
            <p>Em situações graves ou urgentes, a suspensão poderá ocorrer preventivamente e sem aviso prévio.</p>
            <p>O cancelamento motivado por fraude ou uso ilegal poderá resultar na perda dos créditos promocionais. O tratamento de eventual saldo comprado observará a legislação e as circunstâncias do caso.</p>
          </section>

          {/* 22. Disponibilidade */}
          <section id="disponibilidade" className="lgpd-section">
            <h2>22. Disponibilidade da plataforma</h2>
            <p>A Análise Cadastral buscará manter a plataforma disponível e funcional, mas não garante funcionamento ininterrupto.</p>
            <p>O serviço poderá ficar indisponível por:</p>
            <ul>
              <li>manutenção;</li>
              <li>atualização;</li>
              <li>falhas de infraestrutura;</li>
              <li>indisponibilidade de fornecedores;</li>
              <li>problemas de internet;</li>
              <li>ataques cibernéticos;</li>
              <li>eventos de força maior;</li>
              <li>exigências legais ou de segurança.</li>
            </ul>
            <p>Sempre que possível, manutenções programadas serão comunicadas previamente.</p>
          </section>

          {/* 23. Fontes */}
          <section id="fontes" className="lgpd-section">
            <h2>23. Atualização e disponibilidade das fontes</h2>
            <p>A Análise Cadastral poderá utilizar fontes próprias, públicas, licenciadas ou disponibilizadas por fornecedores autorizados.</p>
            <p>A disponibilidade e atualização dos resultados poderão depender de terceiros.</p>
            <p>Determinadas informações poderão:</p>
            <ul>
              <li>estar desatualizadas;</li>
              <li>conter divergências;</li>
              <li>ter sido modificadas recentemente;</li>
              <li>não estar disponíveis;</li>
              <li>apresentar homônimos;</li>
              <li>exigir validação complementar.</li>
            </ul>
            <p>O usuário deverá considerar essas limitações antes de tomar decisões.</p>
          </section>

          {/* 24. Decisões */}
          <section id="decisoes" className="lgpd-section">
            <h2>24. Decisões tomadas pelo usuário</h2>
            <p>Os resultados possuem caráter informativo e auxiliar.</p>
            <p>A Análise Cadastral <strong>não se responsabiliza</strong> por decisões tomadas exclusivamente com base em uma consulta, especialmente relacionadas a:</p>
            <ul>
              <li>contratação;</li>
              <li>concessão de crédito;</li>
              <li>recusa de serviço;</li>
              <li>demissão;</li>
              <li>investigação;</li>
              <li>acusação;</li>
              <li>exposição pública;</li>
              <li>cobrança;</li>
              <li>medidas judiciais;</li>
              <li>conclusões sobre identidade ou conduta.</li>
            </ul>
            <p>O usuário deverá realizar validações adicionais e observar a legislação aplicável antes de tomar decisões que possam afetar terceiros.</p>
          </section>

          {/* 25. Proteção de dados */}
          <section id="protecao-dados" className="lgpd-section">
            <h2>25. Proteção de dados pessoais</h2>
            <p>O tratamento de dados pessoais relacionado à plataforma será realizado conforme a <a href="#">Política de Privacidade</a> da Análise Cadastral.</p>
            <p>A Política de Privacidade integra estes Termos e deverá estar disponível no site.</p>
            <p>O usuário deverá tratar os resultados consultados com segurança e confidencialidade, evitando acesso, compartilhamento ou armazenamento desnecessário.</p>
          </section>

          {/* 26. Comunicações */}
          <section id="comunicacoes" className="lgpd-section">
            <h2>26. Comunicações</h2>
            <p>A Análise Cadastral poderá enviar comunicações relacionadas a:</p>
            <ul>
              <li>confirmação de compra;</li>
              <li>entrega de resultado;</li>
              <li>criação de conta;</li>
              <li>alteração de senha;</li>
              <li>créditos e bônus;</li>
              <li>vencimento de créditos promocionais;</li>
              <li>segurança;</li>
              <li>atualização destes Termos;</li>
              <li>manutenção;</li>
              <li>atendimento;</li>
              <li>novos produtos e ofertas.</li>
            </ul>
            <p>As comunicações essenciais ao serviço poderão ser enviadas independentemente da adesão a mensagens promocionais.</p>
            <p>O usuário poderá cancelar o recebimento de comunicações comerciais pelos mecanismos disponibilizados.</p>
          </section>

          {/* 27. Propriedade intelectual */}
          <section id="propriedade" className="lgpd-section">
            <h2>27. Propriedade intelectual</h2>
            <p>A plataforma, sua identidade visual, textos, sistemas, códigos, bancos de dados, organização, marcas, logotipos, layouts e funcionalidades são protegidos pela legislação aplicável.</p>
            <p>A contratação não transfere ao usuário qualquer direito de propriedade intelectual.</p>
            <p>É proibido:</p>
            <ul>
              <li>copiar ou reproduzir a plataforma;</li>
              <li>realizar engenharia reversa;</li>
              <li>modificar o sistema;</li>
              <li>criar serviço concorrente com base em cópia;</li>
              <li>remover identificações de autoria;</li>
              <li>utilizar a marca sem autorização;</li>
              <li>extrair ou reproduzir os bancos de dados.</li>
            </ul>
            <p>O usuário recebe apenas uma licença limitada, pessoal, revogável e não exclusiva para utilizar os serviços contratados.</p>
          </section>

          {/* 28. Terceiros */}
          <section id="terceiros" className="lgpd-section">
            <h2>28. Links e serviços de terceiros</h2>
            <p>A plataforma poderá utilizar ou disponibilizar links para serviços de terceiros, como:</p>
            <ul>
              <li>meios de pagamento;</li>
              <li>hospedagem de arquivos;</li>
              <li>autenticação;</li>
              <li>atendimento;</li>
              <li>comunicação;</li>
              <li>fornecedores de dados.</li>
            </ul>
            <p>Esses serviços poderão possuir termos e políticas próprios.</p>
            <p>A Análise Cadastral não controla integralmente ambientes externos e não se responsabiliza por práticas independentes de terceiros, sem prejuízo das responsabilidades previstas em lei.</p>
          </section>

          {/* 29. Limitação */}
          <section id="limitacao" className="lgpd-section">
            <h2>29. Limitação de responsabilidade</h2>
            <p>Dentro dos limites permitidos pela legislação, a Análise Cadastral não será responsável por:</p>
            <ul>
              <li>uso ilegal dos resultados pelo usuário;</li>
              <li>decisões tomadas sem validação adequada;</li>
              <li>dados incorretos fornecidos pelo usuário;</li>
              <li>compartilhamento de credenciais;</li>
              <li>acesso por dispositivo desprotegido;</li>
              <li>perda do prazo para utilização de bônus;</li>
              <li>perda do prazo para download de arquivo;</li>
              <li>indisponibilidade causada por terceiros;</li>
              <li>divergências ou desatualizações provenientes das fontes;</li>
              <li>danos decorrentes de condutas contrárias a estes Termos.</li>
            </ul>
            <p>Esta cláusula não exclui responsabilidades que não possam ser afastadas pela legislação.</p>
          </section>

          {/* 30. Indenização */}
          <section id="indenizacao" className="lgpd-section">
            <h2>30. Indenização por uso indevido</h2>
            <p>O usuário poderá ser responsabilizado por prejuízos causados à Análise Cadastral, aos titulares ou a terceiros em decorrência de:</p>
            <ul>
              <li>uso ilegal;</li>
              <li>violação destes Termos;</li>
              <li>compartilhamento indevido;</li>
              <li>fraude;</li>
              <li>vazamento causado por sua conduta;</li>
              <li>infração a direitos de terceiros;</li>
              <li>fornecimento de informações falsas.</li>
            </ul>
            <p>Essa responsabilidade será apurada conforme a legislação aplicável e as circunstâncias do caso.</p>
          </section>

          {/* 31. Encerramento */}
          <section id="encerramento" className="lgpd-section">
            <h2>31. Encerramento da conta pelo usuário</h2>
            <p>O usuário poderá solicitar o encerramento da conta pelo canal:</p>
            <div className="contact-box">
              <a href="mailto:suporte@analisecadastral.com.br">suporte@analisecadastral.com.br</a>
            </div>
            <p>Antes do encerramento, deverá:</p>
            <ul>
              <li>utilizar ou verificar o saldo existente;</li>
              <li>baixar os arquivos que deseje manter;</li>
              <li>resolver pagamentos pendentes;</li>
              <li>cumprir obrigações relacionadas ao uso da plataforma.</li>
            </ul>
            <p>O encerramento poderá resultar na perda de créditos promocionais.</p>
            <p>O tratamento de créditos comprados ainda existentes deverá seguir a política comercial aplicável e a legislação.</p>
            <p>Determinados registros poderão ser preservados após o encerramento para cumprimento de obrigações, segurança, prevenção a fraudes e exercício de direitos.</p>
          </section>

          {/* 32. Alterações dos serviços */}
          <section id="alteracoes-servicos" className="lgpd-section">
            <h2>32. Alterações dos serviços</h2>
            <p>A Análise Cadastral poderá alterar, adicionar ou remover:</p>
            <ul>
              <li>tipos de consulta;</li>
              <li>funcionalidades;</li>
              <li>meios de pagamento;</li>
              <li>pacotes;</li>
              <li>preços;</li>
              <li>consumo de créditos;</li>
              <li>fornecedores;</li>
              <li>regras promocionais;</li>
              <li>interface da plataforma.</li>
            </ul>
            <p>Alterações relevantes serão informadas pelos meios adequados.</p>
            <p>Compras já concluídas continuarão sujeitas às condições apresentadas no momento da contratação, ressalvadas alterações necessárias por lei, segurança ou impossibilidade técnica.</p>
          </section>

          {/* 33. Alterações dos Termos */}
          <section id="alteracoes-termos" className="lgpd-section">
            <h2>33. Alterações destes Termos</h2>
            <p>Estes Termos poderão ser atualizados para refletir:</p>
            <ul>
              <li>mudanças legais;</li>
              <li>novas funcionalidades;</li>
              <li>ajustes comerciais;</li>
              <li>medidas de segurança;</li>
              <li>modificações operacionais;</li>
              <li>novas práticas de tratamento.</li>
            </ul>
            <p>A versão atualizada será publicada com a nova data de revisão.</p>
            <p>Quando a alteração for relevante, a Análise Cadastral poderá solicitar nova aceitação ou enviar uma comunicação ao usuário.</p>
          </section>

          {/* 34. Legislação */}
          <section id="legislacao" className="lgpd-section">
            <h2>34. Legislação aplicável</h2>
            <p>Estes Termos serão interpretados conforme a legislação brasileira.</p>
            <p>Qualquer cláusula considerada inválida ou inexequível deverá ser ajustada ou desconsiderada sem afetar as demais disposições.</p>
            <p>A eventual tolerância ao descumprimento de uma obrigação não representa renúncia de direito.</p>
          </section>

          {/* 35. Foro */}
          <section id="foro" className="lgpd-section">
            <h2>35. Foro</h2>
            <p>Fica eleito o foro da comarca de <strong>Corinto/MG</strong> para resolver controvérsias relacionadas a estes Termos.</p>
            <p>Quando houver relação de consumo, será preservado o direito do consumidor de utilizar o foro legalmente competente, inclusive o de seu domicílio quando aplicável.</p>
          </section>

          {/* 36. Atendimento */}
          <section id="atendimento" className="lgpd-section">
            <h2>36. Atendimento</h2>
            <p>Para dúvidas, reclamações, cancelamentos ou solicitações relacionadas ao serviço:</p>
            <div className="atendimento-card">
              <div className="atendimento-row">
                <span className="atendimento-label">Empresa</span>
                <span className="atendimento-value">Análise Cadastral</span>
              </div>
              <div className="atendimento-row">
                <span className="atendimento-label">E-mail</span>
                <a href="mailto:suporte@analisecadastral.com.br" className="atendimento-value">suporte@analisecadastral.com.br</a>
              </div>
              <div className="atendimento-row">
                <span className="atendimento-label">Horário</span>
                <span className="atendimento-value">Segunda a Sexta, 10:00 às 16:00</span>
              </div>
              <div className="atendimento-row">
                <span className="atendimento-label">Prazo de resposta</span>
                <span className="atendimento-value">1 dia útil</span>
              </div>
            </div>
            <p className="final-note">Ao utilizar a plataforma, o usuário confirma que leu e concordou com estes Termos de Uso.</p>
          </section>
        </main>
      </div>

      {/* Footer */}
      <footer className="lgpd-footer">
        <div className="container">
          <div className="lgpd-footer-inner">
            <p>© Análise Central. Todos os direitos reservados.</p>
            <div className="lgpd-footer-links">
              <a href="/">Página Inicial</a>
              <a href="/lgpd/privacy">Política de Privacidade</a>
              <a href="/lgpd/exclusion">LGPD</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}